module.exports = __webpack_public_path__ + "img/PGD.2bcbbffa.jpg";